import { render, staticRenderFns } from "./SimplePhase.vue?vue&type=template&id=ae4d3cf0&"
import script from "./SimplePhase.vue?vue&type=script&lang=js&"
export * from "./SimplePhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports